import { Skeleton } from '@shared/components/ui/skeleton';
import { TableCell, TableRow } from '@shared/components/ui/table';
import { cn } from '@shared/lib/utils';
import { type Table as TanstackTable } from '@tanstack/react-table';

interface DataTableSkeletonRowsProps<TData> {
  table: TanstackTable<TData>;
  rowCount?: number;
  cellClassName?: string;
  columnClassName?: Record<string, string>;
}

export function DataTableSkeletonRows<TData>({
  table,
  rowCount = 10,
  cellClassName,
  columnClassName = {},
}: DataTableSkeletonRowsProps<TData>) {
  const skeletonRows = Array.from({ length: rowCount }, (_, index) => index);

  return (
    <>
      {skeletonRows.map((rowIndex) => (
        <TableRow key={`skeleton-${rowIndex}`} className={cn('border-b')}>
          {table.getHeaderGroups()[0]?.headers.map((header) => (
            <TableCell
              key={`skeleton-${rowIndex}-${header.id}`}
              className={cn(
                cellClassName as string,
                columnClassName?.[header.column.id] as string
              )}
            >
              {header.column.id === 'select' ? (
                <Skeleton className="size-4 rounded" />
              ) : header.column.id === 'actions' ? (
                <Skeleton className="size-8 rounded" />
              ) : (
                <Skeleton
                  className={cn('h-6 rounded w-full', {
                    'min-w-40': header.column.id
                      .toLocaleLowerCase()
                      .includes('name'),
                    'w-16 float-right': header.column.id === 'emissionFactor',
                  })}
                />
              )}
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
}
